// Tennis — a separate lobby tile that reuses the sports lobby (shared cricket engine,
// sport-scoped). The lobby defaults to the Tennis tab from the /games/tennis route.
import type { GameModule } from '../types';
import Page from '../cricket/Page';

const tennis: GameModule = {
  id: 'tennis',
  displayName: 'Tennis',
  tag: "Sports",
  theme: { gradient: 'from-[#7A5C00] via-[#3d2e00] to-[#1A1400]', emoji: '🎾' },
  orientation: 'any',
  Page,
};

export default tennis;
